import { Injectable } from '@angular/core';
import DynamicFormUtils from '@shared/utils/dynamic-form.utils';

import {
  ReportFrequency,
  WeekdaysFormKeys,
} from '@pages/reports-page/components/report-tabs/report-information-tab/constants';
import {
  ReportInformationTabDto,
  ReportInformationTabForm,
  Role,
  User,
} from '@pages/reports-page/components/report-tabs/report-information-tab/interfaces';
import { DepartmentDto } from '@shared/interfaces/department';
import { DvDynamicFormElement } from '@devinco/ui/legacy';
@Injectable()
export class ReportDataSaveService {
  getReportSettingUpsertPayload(
    formData: ReportInformationTabForm,
    multiselectElements: DvDynamicFormElement[]
  ): ReportInformationTabDto {
    const payload: ReportInformationTabDto = {
      EmptyResultNoReport: !!formData.EmptyResultNoReport,
      DataFilterID: formData.DataFilterID,
      FilterDescription: formData.FilterDescription,
      ReportDescription: formData.ReportDescription,
      ReportTypeID: formData.ReportTypeID,
      Departments:
        DynamicFormUtils.getSelectedDataFromMultiselectDropdown<DepartmentDto>(
          multiselectElements.find(el => el.options.key === 'Departments')!,
          formData.Departments,
          'DepartmentID'
        ).map(department => ({
          DepartmentID: department.DepartmentID,
          DepartmentDescription: department.DepartmentDescription,
        })),
      Roles: DynamicFormUtils.getSelectedDataFromMultiselectDropdown<Role>(
        multiselectElements.find(el => el.options.key === 'Roles')!,
        formData.Roles,
        'RoleID'
      ).map(role => ({
        RoleID: role.RoleID,
        Name: role.Name,
      })),
      Users: DynamicFormUtils.getSelectedDataFromMultiselectDropdown<User>(
        multiselectElements.find(el => el.options.key === 'Users')!,
        formData.Users,
        'UserID'
      ).map(user => ({
        UserID: user.UserID,
        UserDescription: user.UserDescription,
      })),
      Frequency: formData.Frequency,
      RecurrenceActive: !!formData.RecurrenceActive,
      RecurrenceStartTime: formData.RecurrenceStartTime,
      Interval: formData.Interval || 1,
      ByDay: this.constructByDayArray(formData),
      ByMonth: this.getByMonthValue(
        formData.ByMonthWithDay,
        formData.ByMonthWithOffset
      ),
      ByMonthDay: formData.ByMonthDay ? [formData.ByMonthDay] : [],
      Offset: formData.Offset,
    };

    return payload;
  }

  private getByMonthValue(
    byMonthWithDay?: number,
    byMonthWithOffset?: number
  ): number[] {
    if (byMonthWithDay) {
      return [byMonthWithDay];
    }

    if (byMonthWithOffset) {
      return [byMonthWithOffset];
    }

    return [];
  }

  private constructByDayArray(formData: ReportInformationTabForm): number[] {
    const frequency = formData.Frequency;
    const selectedValues: number[] = [];
    if (frequency === ReportFrequency.Weekly) {
      Object.values(WeekdaysFormKeys).forEach(weekday => {
        if (formData[weekday]) {
          selectedValues.push(Number(weekday));
        }
      });
    } else if (
      frequency === ReportFrequency.Monthly ||
      frequency === ReportFrequency.Yearly
    ) {
      selectedValues.push(formData.ByDay as number);
    }
    return selectedValues.filter(val => val || val === 0);
  }
}
